import {Controller} from 'stimulus';

export default class extends Controller {
  upgrade() {
    const billing_cycle = $('input[name=\'subscription[billing_cycle]\']:checked')[0].value;
    $(`.${billing_cycle}-payment .plan-${this.data.get('plan')}`)[0].click();
  }
}
